// extracted by mini-css-extract-plugin
module.exports = {"animated":"AnimatedHeight_animated__YnmTS","content":"AnimatedHeight_content__L93cx"};